import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ApiValidationError } from 'contracts/Common';
import type { CreatePhysicalDocksBulkPayload } from 'contracts/PhysicalDocks';

const { Types, Creators } = createActions(
  {
    request: ['postData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage', 'validationErrors'],
    softReset: [],
    reset: [],
  },
  { prefix: 'CREATE_PHYSICAL_DOCKS_BULK_' }
);

export interface CreatePhysicalDocksBulkState {
  loading: boolean;
  errorMessage: string | null;
  validationErrors: ApiValidationError[];
}

export interface CreatePhysicalDocksBulkRequestAction {
  postData: CreatePhysicalDocksBulkPayload;
  onSuccess?: () => boolean | void;
  onFailure?: () => boolean | void;
}

interface FailureAction {
  errorMessage: string;
  validationErrors?: ApiValidationError[];
}

const INITIAL_STATE: CreatePhysicalDocksBulkState = {
  loading: false,
  errorMessage: null,
  validationErrors: [],
};

const request = (state: CreatePhysicalDocksBulkState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
    validationErrors: { $set: [] },
  });

const success = (state: CreatePhysicalDocksBulkState) =>
  update(state, { loading: { $set: false } });

const failure = (state: CreatePhysicalDocksBulkState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
    validationErrors: { $set: action.validationErrors || [] },
  });

const softReset = (state: CreatePhysicalDocksBulkState) =>
  update(state, { loading: { $set: false } });

const reset = () => INITIAL_STATE;

export const createPhysicalDocksBulk = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const CreatePhysicalDocksBulkTypes = Types;
export const CreatePhysicalDocksBulkActions = Creators;
